import templateUrl from './autocomplete.html';
import map from 'lodash/map';
import filter from 'lodash/filter';
import last from 'lodash/last';
import clone from 'lodash/clone';
import escapeRegExp from 'lodash/escapeRegExp';
import reduce from 'lodash/reduce';

export const autocompleteComponent = {
	bindings: {
		items: '<',
		defaultSelected: '<',
		onSelectItem: '&',
		onRemoveTag: '&',
		onAutocomplete: '&',
		placeholder: '@',
		defaultTextboxValue: '<',
		isDisabled: '@',
		isRequired: '@',
		minCharcterRequired: '@',
		templateUrl: '@',
		placeHolder: '@',
		onChangeText: '&',
		allowRepeat: '<'
	},
	templateUrl,
	controller: class AutocompleteComponent {
		constructor($parse, $timeout) {
			'ngInject';

			this.$parse = $parse;
			this.showCustomTemplate = false;
			this.isRequired = true;
			this.$timeout = $timeout;
			this.isEmptyResult = false;
		}

		$onInit() {
			this._items = clone(this.items);
			this._isDisabled = this.$parse(this.isDisabled || 'false')(false);
			this.isRequired = _convertToBoolean(this.isRequired, this.$parse);
			this.searchText = this.defaultTextboxValue || '';
			this.tags = [];
			if (this.defaultSelected) {
				this.tags = this._getDefaultSubject(this.defaultSelected);
			}
			if (this.allowRepeat == undefined) {
				this.allowRepeat = false;
			}
			this.uniqIdForAutocompleteInput = this._getUniqIdForAutocompleteInput();
		}
		resetSearchText() {
			if (this.searchText === ' ') {
				this.searchText = '';
			}
		}

		onClick(event) {
			let element = angular.element(event.target);
			if (element.hasClass('main-tag') || element.hasClass('autocomplete')) {
				this.$timeout(() => {
					angular.element(document.getElementById(this.uniqIdForAutocompleteInput))[0].focus();
				}, 100);

			}
		}

		_getUniqIdForAutocompleteInput() {
			return `autocomplete-${this._getRandomId()}`;
		}

		_getRandomId( idLength = 5 ) {
			const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
			return reduce([...Array(idLength).keys()], (id, index) => {
				return id += possible.charAt(Math.floor(Math.random() * possible.length));
			}, 0);
		}

		_getDefaultSubject(subjects) {
			let subjectsWithoutDeleted = filter(subjects, ({ status }) => {
				return status !== 2;
			});
			let _subjects = map(subjectsWithoutDeleted, function (sub) {
				return sub.name;
			});
			return _subjects;
		}
		_onItemSelect(item) {
			if (this.tags.indexOf(item.name) === -1) {
				this.tags.push(item.name);
			}
			this.searchText = this.defaultTextboxValue || '';
			this.onSelectItem({
				$item: item
			});
		}
		_onTagRemove($event) {
			this.tags = this.tags.filter((value) => {
				return value !== $event.tag;
			});
			this.onRemoveTag({
				$event: $event.tag
			})

		}
		onKeyDown($event) {
			if ($event.keyCode === 8) {
				if (this.searchText === "" || this.searchText === " ") {
					if (this.tags.length != 0) {
						let last = last(this.tags);
						this.tags = this.tags.filter((value) => {
							return value !== last;
						});
						this.onRemoveTag({
							$event: last
						});
					}
				}
			}
		}
		_onChangeText() {
			this.onChangeText({
				$event: this.searchText
			})
		}
		$onChanges(changes) {
			if (changes.defaultSelected && !changes.defaultSelected.isFirstChange()) {
				this.defaultSelected = changes.defaultSelected.currentValue;
				this.$onInit();
			}
			if (changes.isRequired) {
				this.isRequired = _convertToBoolean(changes.isRequired.currentValue, this.$parse);
			}
			if (changes.isDisabled) {
				this._isDisabled = _convertToBoolean(changes.isDisabled.currentValue, this.$parse);
			}
			if (changes.defaultTextboxValue) {
				this.searchText = changes.defaultTextboxValue.currentValue;
			}
		}

		_onAutocomplete(value) {
			return this.onAutocomplete({
				$event: value
			}).then((details) => {
				if (details.length != 0) {
					return details;
				}
				return null;
			})
		}

		$onChanges(changes) {
			if (changes && changes.items) {
				this.items = changes.items.currentValue;
			}
			this.$onInit();
		}
	}
};
function _convertToBoolean(value, $parse) {
	return $parse(value)(false);
}


// WEBPACK FOOTER //
// ./src/app/common/components/autocomplete/autocomplete.component.js